import { useState } from "react";
import { AlertCircle, CheckCircle, Clock, FileText } from "lucide-react";
import DocumentModal from "../Modal/DocumentModal";
import useEmployeeDocumentPersonal from "../../../../../hooks/Employee/useEmployeeDocumentPersonal";

const documentItems = [
  {
    id: "1",
    title: "Credit Check, PEP & Sanctions",
    status: "uploaded",
    type: "creditcheck",
  },
  {
    id: "2",
    title: "Identity Document 2",
    status: "pending",
    type: "identity",
  },
  {
    id: "3",
    title: "Driving Licence",
    status: "uploaded",
    type: "drivinglicence",
  },
  {
    id: "4",
    title: "Identity Document 2 Rear",
    status: "pending",
    type: "identityrear",
  },
  {
    id: "5",
    title: "Driving Licence (Rear)",
    status: "uploaded",
    type: "drivinglicencerear",
  },
  { id: "6", title: "Proof of Address 1", status: "uploaded", type: "address" },
  { id: "7", title: "Passport/VISA", status: "pending", type: "passport" },
  {
    id: "8",
    title: "Proof of Address 2",
    status: "uploaded",
    type: "addressrear",
  },
  {
    id: "9",
    title: "Passport/VISA Rear",
    status: "pending",
    type: "passportrear",
  },
  {
    id: "10",
    title: "SIA Licence Front",
    status: "uploaded",
    type: "sialicence",
  },
  {
    id: "11",
    title: "Identity Document 1",
    status: "uploaded",
    type: "identityfront",
  },
  {
    id: "12",
    title: "SIA Licence Rear",
    status: "uploaded",
    type: "sialicencerear",
  },
  {
    id: "13",
    title: "Identity Document 1 Rear",
    status: "uploaded",
    type: "identityfrontrear",
  },
  {
    id: "14",
    title: "SIA Initial Validation Check",
    status: "uploaded",
    type: "initialvalidation",
  },
];
export default function EmployeDocForm() {
  const [showModal, setShowModal] = useState(false);
  const [documentType, setDocumentType] = useState(null);
  const { documents, refetch } = useEmployeeDocumentPersonal();

  const getStatusColor = (status) => {
    switch (status) {
      case "uploaded":
        return "text-primary";
      case "pending":
        return "text-danger";
      case "required":
        return "text-warning";
      default:
        return "text-primary";
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case "uploaded":
        return <CheckCircle size={16} className="text-success" />;
      case "pending":
        return <Clock size={16} className="text-warning" />;
      case "required":
        return <AlertCircle size={16} className="text-danger" />;
      default:
        return <CheckCircle size={16} className="text-success" />;
    }
  };

  const handleOpenModal = (documentType) => {
    setDocumentType(documentType);
    setShowModal(true);
  };
  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <>
      <div className="col-md-12">
        <div className="row">
          <div className="col-md-12">
            <div className="panel panel-default">
              <div className="document-upload-container">
                <div className="container-fluid px-4">
                  {/* Header */}
                  <div className="mb-4">
                    <h2 className="document-header">Documents</h2>
                    <p className="document-status">Uploaded</p>
                  </div>
                  <div className="document-grid">
                    {documentItems.map((item) => {
                      const typeDocs = documents[item.type];
                      const docExists = typeDocs && typeDocs.length > 0;
                      const status = docExists ? "uploaded" : "pending";

                      return (
                        <div key={item.id} className="document-card-wrapper">
                          <div
                            className="document-card"
                            onClick={() => handleOpenModal(item.type)}
                             style={{
                                  border: docExists
                                    ? "1px solid #ccc"
                                    : "1px solid red",
                                  background: docExists
                                    ? "white"
                                    : "rgb(251 231 232)",
                                }}
                          >
                            <div className="document-icon-container">
                              <FileText className="document-icon" size={24} />
                            </div>
                            <div className="document-content">
                              <span
                                className={`document-title ${
                                  documents[item.type] &&
                                  documents[item.type].length > 0
                                    ? getStatusColor("uploaded")
                                    : getStatusColor("pending")
                                } `}
                                style={{
                                  color:
                                    status === "uploaded"
                                      ? "#0083ff"
                                      : "#f22e2e",
                                }}
                              >
                                {item.title}
                              </span>
                              <div className="document-status-indicator d-flex gap-2 align-items-center">
                                {documents[item.type] &&
                                documents[item.type].length > 0
                                  ? getStatusIcon("uploaded")
                                  : getStatusIcon("pending")}
                                <span className="status-text">
                                  {documents[item.type] &&
                                  documents[item.type].length > 0
                                    ? "Uploaded"
                                    : "Pending"}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>

                <style jsx>{`
                  .document-grid {
                    display: grid;
                    grid-template-columns: 1fr;
                    gap: 16px;
                  }

                  @media (min-width: 768px) {
                    .document-grid {
                      grid-template-columns: repeat(2, 1fr);
                    }
                  }

                  @media (min-width: 1024px) {
                    .document-grid {
                      grid-template-columns: repeat(3, 1fr);
                    }
                  }

                  .document-card-wrapper {
                    width: 100%;
                  }

                  .document-upload-container {
                    background-color: #f8f9fa;
                    min-height: 100vh;
                    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI",
                      Roboto, sans-serif;
                  }

                  .document-header {
                    font-size: 2.5rem;
                    font-weight: 600;
                    color: #333;
                    margin-bottom: 0.25rem;
                  }

                  .document-status {
                    color: #6c757d;
                    font-size: 0.9rem;
                    margin-bottom: 0;
                  }

                  .document-card {
                    background: white;
                    border-radius: 4px;
                    // padding: 4px;
                    display: flex;
                    align-items: center;
                    gap: 0.75rem;
                    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
                    border: 1px solid #e9ecef;
                    transition: all 0.2s ease;
                    // height: 80px;
                    position: relative;
                    overflow: hidden;
                  }

                  .document-card:hover {
                    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
                    transform: translateY(-1px);
                  }

                  .document-icon-container {
                    background: #0083ff;
                    // border-radius: 4px;
                    padding: 0.75rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-shrink: 0;
                    width: 48px;
                    height: 48px;
                  }

                  .document-icon {
                    color: white;
                  }

                  .document-content {
                    flex: 1;
                    min-width: 0;
                  }

                  .document-title {
                    font-size: 1.3rem;
                    font-weight: 500;
                    line-height: 1.3;
                    display: block;
                    word-wrap: break-word;
                  }

                  .text-primary {
                    color: #007bff !important;
                  }

                  .text-danger {
                    color: #dc3545 !important;
                  }

                  .text-warning {
                    color: #ffc107 !important;
                  }

                  /* Responsive adjustments */
                  @media (max-width: 576px) {
                    .document-card {
                      padding: 0.75rem;
                      height: auto;
                      min-height: 60px;
                    }

                    .document-icon-container {
                      width: 40px;
                      height: 40px;
                      padding: 0.5rem;
                    }

                    .document-title {
                      font-size: 0.8rem;
                    }
                  }

                  @media (min-width: 1200px) {
                    .col-xl-3 {
                      flex: 0 0 auto;
                      width: 25%;
                    }
                  }

                  @media (min-width: 1400px) {
                    .col-xl-3 {
                      width: 20%;
                    }
                  }
                `}</style>
              </div>
            </div>
          </div>
        </div>
      </div>

      <DocumentModal
        showModal={showModal}
        handleClose={handleClose}
        documentType={documentType}
        refetch={refetch}
        documents={documents}
      />
    </>
  );
}
